import React from 'react';

const ArrowIcon = () => {

  return (
    <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="32" rx="16" fill="#EBEDEF"/>
      <path d="M25.1005 16H14.9004" stroke="#08081B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.8496 11.75L25.0997 16.0001L20.8496 20.2501" stroke="#08081B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default ArrowIcon;